jQuery(document).ready(function($) {
    console.log('[QueryCard] Script loaded');
    
    const $blocks = $('.wp-block-jormi-blocks-query-card');
    console.log('[QueryCard] Found blocks:', $blocks.length);
    
    const $triggers = $blocks.find('[data-hs-overlay]');
    console.log('[QueryCard] Found panel triggers:', $triggers.length);
    
    if ($blocks.length === 0) { 
        console.log('[QueryCard] No blocks found, exiting');
        return; 
    }
    
    // Get scrollbar width to prevent layout shift
    const getScrollbarWidth = () => {
        return window.innerWidth - document.documentElement.clientWidth;
    };
    
    // Side panel overlay functionality
    if ($triggers.length > 0) {
        $triggers.on('click', function(e) {
            e.preventDefault();
            
            const overlayId = $(this).data('hs-overlay');
            const $overlay = $(overlayId);
            const scrollbarWidth = getScrollbarWidth();

            $('html').css('overflow', 'hidden');
            if (scrollbarWidth > 0) {
                $('body').css('margin-right', scrollbarWidth + 'px');
            }
    
            $overlay.css({ display: 'flex', opacity: '0' })
                    .animate({ opacity: 1 }, 300);
            
            const $panel = $overlay.find('.query-card__panel-container');
            $panel.css({ 
                'transform': 'translateX(100%)',
                'opacity': '0'
            }).animate({ 
                opacity: 1 
            }, 300, 'swing');
            
            setTimeout(function() {
                $panel.css('transform', 'translateX(0)');
            }, 10);
            
            const $closeButton = $overlay.find('.query-card__panel-close');
            $closeButton.one('click', function() {
                const $panel = $overlay.find('.query-card__panel-container');
                $panel.animate({ opacity: 0 }, 250, function() {
                    $(this).css('transform', 'translateX(100%)');
                });
                $overlay.animate({ opacity: 0 }, 250, function() {
                    $overlay.css({display: 'none'});
                });
                $('html').css('overflow', 'auto');
                $('body').css('margin-right', '0');
            });
            
            $overlay.on('click', function(e) {
                if (e.target === this) {
                    const $panel = $overlay.find('.query-card__panel-container');
                    $panel.animate({ opacity: 0 }, 250, function() {
                        $(this).css('transform', 'translateX(100%)');
                    });
                    $overlay.animate({ opacity: 0 }, 250, function() {
                        $overlay.css({display: 'none'});
                    });
                    $('html').css('overflow', 'auto');
                    $('body').css('margin-right', '0');
                    $(this).off('click');
                }
            });
        });
        
        $(document).on('keyup', function(e) {
            if (e.key === 'Escape') {
                const $openOverlay = $('.query-card__panel.hs-overlay:visible');
                if ($openOverlay.length) {
                    const $panel = $openOverlay.find('.query-card__panel-container');
                    $panel.animate({ opacity: 0 }, 250, function() {
                        $(this).css('transform', 'translateX(100%)');
                    });
                    $openOverlay.animate({ opacity: 0 }, 250, function() {
                        $openOverlay.css({display: 'none'});
                    });
                }
                $('html').css('overflow', 'auto');
                $('body').css('margin-right', '0');
            }
        });
    }

    // Accordion functionality
    console.log('[QueryCard] Looking for accordion items');
    const $accordionItems = $('.query-card--display-accordion');
    console.log('[QueryCard] Found accordion items:', $accordionItems.length);
    
    if ($accordionItems.length === 0) {
        return;
    }
    
    // Initialize all accordions as collapsed
    $accordionItems.addClass('is-collapsed');
    
    const $expanders = $accordionItems.find('.query-card__expander');
    console.log('[QueryCard] Found expanders:', $expanders.length);
    $expanders.hide();

    // Check for js-expander elements
    const $jsExpanders = $accordionItems.find('.js-expander');
    console.log('[QueryCard] Found .js-expander elements:', $jsExpanders.length);

    // Click on the card inner (js-expander) to expand
    $jsExpanders.on('click', function(e) {
        console.log('[QueryCard] js-expander clicked, target:', e.target.tagName);
        
        // Check if we clicked on an actual navigation link (with real href, not "#")
        const $clickedLink = $(e.target).closest('a');
        if ($clickedLink.length) {
            const href = $clickedLink.attr('href');
            console.log('[QueryCard] Clicked link href:', href);
            
            // Only ignore if it's a real link (not empty, not just "#", not javascript:void)
            if (href && href !== '#' && href !== '' && !href.startsWith('javascript:')) {
                console.log('[QueryCard] Real link clicked, ignoring accordion toggle');
                return;
            }
        }
        
        // Prevent default and stop the accordion toggle
        e.preventDefault();
        e.stopPropagation();
        
        const $thisItem = $(this).closest('.query-card--display-accordion');
        const $expander = $thisItem.find('.query-card__expander');
        
        console.log('[QueryCard] Current state - is-collapsed:', $thisItem.hasClass('is-collapsed'));

        if ($thisItem.hasClass('is-collapsed')) {
            console.log('[QueryCard] Expanding accordion');
            
            // Close all other accordion items with animation
            $accordionItems.not($thisItem).each(function() {
                const $otherItem = $(this);
                const $otherExpander = $otherItem.find('.query-card__expander');
                
                if ($otherItem.hasClass('is-expanded')) {
                    $otherExpander.slideUp(250, 'swing', function() {
                        $otherItem.removeClass('is-expanded').addClass('is-collapsed');
                    });
                } else {
                    $otherItem.addClass('is-inactive');
                }
            });
            
            // Slight delay for smoother sequential animation
            setTimeout(function() {
                $thisItem.removeClass('is-collapsed').addClass('is-expanded');
                $expander.slideDown(350, 'swing', function() {
                    console.log('[QueryCard] Accordion expanded, expander visible');
                });
            }, 100);

        } else {
            console.log('[QueryCard] Collapsing accordion');
            $thisItem.removeClass('is-expanded').addClass('is-collapsed');
            $expander.slideUp(250, 'swing');
            $accordionItems.not($thisItem).removeClass('is-inactive');
        }
    });

    // Click on close button to collapse
    const $collapsers = $accordionItems.find('.js-collapser');
    console.log('[QueryCard] Found .js-collapser elements:', $collapsers.length);
    
    $collapsers.on('click', function(e) {
        console.log('[QueryCard] js-collapser clicked');
        e.stopPropagation();
        e.preventDefault();
        
        const $thisItem = $(this).closest('.query-card--display-accordion');
        const $expander = $thisItem.find('.query-card__expander');
        
        $expander.slideUp(250, 'swing', function() {
            $thisItem.removeClass('is-expanded').addClass('is-collapsed');
            $accordionItems.not($thisItem).removeClass('is-inactive');
        });
    });
    
    console.log('[QueryCard] Setup complete');
});